/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type ServiceOrdersAttachmentsDestroyRequest = {} | null | undefined;
export type ServiceOrdersAttachmentsDestroyResponse = any;

export type ServiceOrdersAttachmentsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: attachment_id
   * schema:
   *   type: string
   *   pattern: ^\d+$
   * required: true
   * ```
   */
  attachment_id?: string;

  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/service_orders/{id}/attachments/{attachment_id}/
 *
 * ```yaml
 * operationId: service_orders_attachments_destroy
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '404':
 *     description: Unknown attachment
 * ```
 */
export const serviceOrdersAttachmentsDestroyOperation = ({
  id,
  attachment_id,
  ...rest
}: ServiceOrdersAttachmentsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/service_orders/${id}/attachments/${attachment_id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/attachments/{attachment_id}/' };
  };

/**
 * DELETE /dmx-server/service_orders/{id}/attachments/{attachment_id}/
 *
 * ```yaml
 * operationId: service_orders_attachments_destroy
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '404':
 *     description: Unknown attachment
 * ```
 */
export const serviceOrdersAttachmentsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersAttachmentsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = serviceOrdersAttachmentsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
